import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Navigate, Outlet, useLocation } from "@tanstack/react-router";
import { lazy, useEffect } from "react";
import { CuiBanner } from "../components/CuiBanner";
import { isGovCloud } from "../config";

const TanStackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? () => null // Render nothing in production
    : lazy(() =>
        // Lazy load in development
        import("@tanstack/react-router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      );

const Root = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isGovCloud) {
      document.body.classList.add("govcloud");
    }
  }, []);

  if (pathname === "/") {
    return <Navigate to="/orgs" />;
  }

  return (
    <>
      {isGovCloud && <CuiBanner position="top" />}
      <Outlet />
      {isGovCloud && <CuiBanner position="bottom" />}
      <TanStackRouterDevtools
        toggleButtonProps={{
          className: "origin-bottom-left rotate-90 -translate-x-2 -translate-y-56 !rounded-b-none",
        }}
      />
    </>
  );
};

type RouterContext = {
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
});
